<template>
    <ol-style :overrideStyleFunction="overrideStyleFunction">
    </ol-style>
</template>



<script setup>

import { ref, computed, onMounted } from 'vue'
import * as olExtent from 'ol/extent';

import { Circle, Fill, Stroke, Style, RegularShape} from 'ol/style.js';
import { LineString, Point } from 'ol/geom.js';
import { Text } from 'ol/style.js';

import { useDataStore } from "@/store/data";

import { useRuntimeStore } from '@/store/runtime';

const dataStore = useDataStore();
const runtimeStore = useRuntimeStore();



const props = defineProps({
    selected: {
        type: Boolean,
        default: false,
    }
})


const glyphPointMainCircle = "󰝥"
const glyphPointMainCircleSelected = "󰝦"

const glyphPointMainMarker = "󰍎"
const glyphPointMainMarkerSelected = "󰍎"



const glyphStart = "󰐊"
const glyphEnd = "󰅜"

const errorsStates = [409, 422, 500]
const farBreakPoint = 50
const regularFontSize = 40
const todayFontSize = 72

const zIndex = ref(1)
// if (props.selected) {
// }



onMounted(() => {


})



// colors

const coolBlue = "#00aaff"
const black = "#000000"
const darkGrey = "#666666"
const lightGrey = "#aaaaaa"
const shadowColor = "#00000044"
const greenyellow = "#adff2f"


/* eslint-disable no-unused-vars */
const overrideStyleFunction = (feature, style, resolution) => {

    const model = feature.get('model');
    const label = feature.get('label');
    const uuid = feature.get('uuid');
    const state = feature.get('state')

    const data = dataStore.getDataFromFeatureUUID(uuid)

    let isToday = false

    if (data?.node?.name === dataStore.trackerTodayName) {
        isToday = true
    }

    // console.log(data)

    const geometry = feature.getGeometry();
    const gExt = geometry.getExtent()
    const centerPoint = olExtent.getCenter(gExt)
    // const centerPointError = [centerPoint[0]+48*resolution, centerPoint[1]+48*resolution]
    const centerPointError = [centerPoint[0], centerPoint[1] - 32 * resolution]
    const centerPointShadow = [centerPoint[0], centerPoint[1] - 3 * resolution]


    // // 5798522 is maximum y coordinate (much over vda)

    // // miny of 
    // // Extent{Array.<number>}
    // // An array of numbers representing an extent: [minx, miny, maxx, maxy].
    const miny = gExt[1]
    // // console.log(`label, y: ${label}, ${miny}`)
    // // main_style.setZIndex(miny)

    if (!props.selected) {
        zIndex.value = 5798522 - parseInt(miny)
    }

    if (props.selected) {
        zIndex.value = 5798522
    }


    let labelStyle = null

    const dataModel = dataStore.ventaglio_possibili.find((v) => v.modelCamel == model)
    
    // console.log("cerco d", dataStore.ventaglio_possibili)
    // console.log("trovato dataModel", dataModel)

    const fillShadow = new Fill({
        color: shadowColor
    })

    let fillColor = "#ffffff"


    // character = "aaa"

    let radius = 18
    let mainIconFontSize = regularFontSize



    // console.log(fillColor)

    const fill = new Fill({
        color: fillColor,
    });


    const fillLinesFar = new Fill({
        color: "#333333",
    });




    const strokeBlack = new Stroke({
        color: coolBlue,
        width: 3,
    });

    if (isToday) {
        mainIconFontSize = todayFontSize
    }



    // console.log(layer.value.name)
    fill.setColor("red")
    const new_styles = []
    const main_style =
        new Style({
            text: new Text({
                // font: '20px sans-serif',
                // textAlign: 'center',
                // textBaseline: 'bottom',
                // text: model,
                // // text: dataModel?.emoji,
                // text: zIndex.value
            })
        })



    if (geometry.getType() === "Polygon") {


        if (resolution < farBreakPoint) {
            zIndex.value = zIndex.value - 5798522
        }

        let fillOpacity = "88"
        let strokeOpacyty = "ff"

        if (resolution >= farBreakPoint) {
            fillOpacity = "55"
            strokeOpacyty = "55"
        }


        main_style.setStroke(new Stroke({
            color: black + strokeOpacyty,
            width: 3
        }))

        let modelFillColor = lightGrey

        
        if (dataModel) {
            if (isToday) {
                modelFillColor = dataModel.color
            }
            fillColor = (dataModel?.color || "#ff0000") 
        }

        if (props.selected) {
            fillColor = greenyellow
            modelFillColor = greenyellow
        }


        main_style.setFill(
            new Fill({
                color: fillColor + fillOpacity,
            }))


        const farStyle = new Style({
            geometry: new Point(centerPoint),
            text: new Text({
                stroke: strokeBlack,
                // text: modelFillColor,
                text: dataModel?.glyph,
                font: `normal normal normal ${mainIconFontSize}px/1 "Material Design Icons`,
                textAlign: 'center',
                textBaseline: 'middle',
                fill: new Fill({ color: modelFillColor }),
            })
        })

        if (resolution >= farBreakPoint) {
            new_styles.push(farStyle)
        }
        if (resolution < farBreakPoint) {
        }

        new_styles.push(main_style)
    }

    if (geometry.getType() === "LineString") {


        if (resolution < farBreakPoint) {
            zIndex.value = zIndex.value - 5798522
        }


        let lineShadowOpacyty = "dd"
        let lineOpacyty = "ff"

        if (resolution >= farBreakPoint) {
            lineShadowOpacyty = "55"
            lineOpacyty = "55"
        }

        // if (props.selected) {
        const shadow_style =
            new Style({
                geometry: new LineString(geometry.getCoordinates()),
                stroke: new Stroke({
                    color: black + lineShadowOpacyty,
                    width: 10
                }),
                zIndex: 1
            })

        new_styles.push(shadow_style)
        // }



        const startPoint = geometry.getFirstCoordinate()
        const endPoint = geometry.getLastCoordinate()
        const x = (startPoint[0] + endPoint[0]) / 2
        const y = (startPoint[1] + endPoint[1]) / 2
        // const midPoint2 = geometry.getFlatMidpoint()
        // const midPoint3 =  geometry.getCoordinateAt()
        // console.log(midPoint)
        // console.log(midPoint2)
        // console.log(midPoint3)


        let modelFillColor = lightGrey
        let strokeLineColor = lightGrey
        let width = 5

        if (isToday) {
            modelFillColor = dataModel?.color || "#999999"
            strokeLineColor = coolBlue + lineOpacyty
        }

        if (dataModel) {
            fillColor = dataModel?.color || "#ff0000"
        }

        if (props.selected) {
            strokeLineColor = greenyellow + lineOpacyty
            modelFillColor = greenyellow
            width = 5
        }

        main_style.setStroke(new Stroke({
            color: strokeLineColor,
            width: width
        }))
        main_style.setZIndex(10)

        const farStyle = new Style({
            geometry: new Point(centerPoint),
            // image: new Circle({
            //     fill: new Fill({
            //         color: "#0006"
            //     }),
            //     radius: 15,

            // }),

            text: new Text({
                stroke: strokeBlack,
                text: dataModel?.glyph,
                font: `normal normal normal ${mainIconFontSize}px/1 "Material Design Icons"`,
                textAlign: 'center',
                textBaseline: 'middle',
                fill: new Fill({ color: modelFillColor }),
            })
        })

        // const startStyle = new Style({
        //     geometry: new Point(startPoint),
        //     // image: new Circle({
        //     //     fill: fillShadow,
        //     //     radius: 5,
        //     // }),
        //     text: new Text({
        //         text: glyphStart,
        //         font: 'normal normal normal 24px/1 "Material Design Icons',
        //         textAlign: 'center',
        //         textBaseline: 'bottom',
        //         fill: fillLinesFar,
        //         stroke: strokeBlack,
        //         offsetY: (-24 / 2.5)

        //     })
        // })
        const startStyle = new Style({
            geometry: new Point(startPoint),
            // image: new Circle({
            //     fill: new Fill({
            //         color: "#0006"
            //     }),
            //     radius: 15,

            // }),

            text: new Text({
                stroke: strokeBlack,
                text: dataModel?.glyph,
                font: `normal normal normal 32px/1 "Material Design Icons"`,
                textAlign: 'center',
                textBaseline: 'middle',
                fill: new Fill({ color: modelFillColor }),
                offsetY: (-50 / 2.5),
            })
        })

        const endStyle = new Style({
            geometry: new Point(endPoint),
            // image: new Circle({
            //     fill: fillShadow,
            //     radius: 5,
            // }),
            text: new Text({
                text: glyphEnd,
                font: 'normal normal normal 16px/1 "Material Design Icons',
                textAlign: 'center',
                textBaseline: 'bottom',
                fill: new Fill({ color: "darkgrey" }),
                stroke: strokeBlack,
                offsetY: (-24 / 2.5)

            })
        })

        if (resolution >= farBreakPoint) {
            new_styles.push(farStyle)
        }
        if (resolution < farBreakPoint) {
            new_styles.push(startStyle)
            new_styles.push(endStyle)
        }



        new_styles.push(main_style)


    }

    if (geometry.getType() === "Point") {

        labelStyle = new Style({
            geometry: new Point(centerPointError),
            text: new Text({
                text: label,
                font: 'bold 20px sans-serif',
                textAlign: 'center',
                textBaseline: 'middle',
                fill: new Fill({ color: "black" }),
                stroke: new Stroke({
                    color: "#ffffffdd",
                    width: 15,
                }),
                // offsetX: 24,
                offsetY: 10,
            })
        })


        // console.log("======================")
        // console.log(runtimeStore.session.map.zoom)
        // console.log(resolution)
        if (
            runtimeStore.session.settings.showMapLabels &&
            // runtimeStore.session.map?.zoom > 14
            resolution < 9.4
        ) {
            if (dataModel.id != "phytosociological") {
                new_styles.push(labelStyle)
            }
        }

        let fillColor = lightGrey

        if (isToday) {
            if (dataModel) {
                fillColor = dataModel?.color + "ff"
            }
        }

        else {
            if (dataModel) {
                fillColor = dataModel?.color + "ff"
            }
        }


        if (model == "PhytoSociological") {
            if (dataModel) {
                fillColor = dataModel?.color
                mainIconFontSize = todayFontSize

            }
        }


        let pointGlyph = glyphPointMainCircle
        let pointGlyphSelected = glyphPointMainCircleSelected
        let actualGliph = pointGlyph
        let offsetY = 0

        if (runtimeStore.session.settings.pointStyle === "marker") {

            if (dataModel?.glyph)
            {
                pointGlyph = dataModel?.glyph
                pointGlyphSelected = dataModel?.glyph
            }
            else {
                pointGlyph = glyphPointMainMarker
                pointGlyphSelected = glyphPointMainMarkerSelected
            }

            offsetY = -mainIconFontSize / 2.5


        }

        actualGliph = pointGlyph
        
        if (props.selected) {
            fillColor = greenyellow
            // selectedIndex = 10000
            actualGliph = pointGlyphSelected
        }

        main_style.setStroke(strokeBlack)


        if (runtimeStore.session.settings.pointStyle === "marker") {

            const shadow_style =
                new Style({
                    geometry: new Point(centerPointShadow),
                    image: new Circle({
                        fill: fillShadow,
                        radius: 15,
                        scale: [1, 0.6],
                    }),
                    zIndex: 1,
                })

            new_styles.push(shadow_style)
        }





        // main_style.setText(character)

        // debugger

        main_style.getText().setFont(`normal normal normal ${mainIconFontSize}px/1 "Material Design Icons"`);
        // set color
        main_style.getText().setFill(new Fill({
            color: fillColor
        }));
        main_style.getText().setStroke(new Stroke({
            color: "black",
            width: 5
        }));
        main_style.getText().setTextAlign('center')
        main_style.getText().setTextBaseline('middle')
        main_style.getText().setPlacement('point')
        main_style.getText().setOffsetX(0)
        main_style.getText().setRotation(0)

        main_style.getText().setOffsetY(offsetY)
        main_style.getText().setText(actualGliph)

        new_styles.push(main_style)
    }



    if (errorsStates.includes(state)) {

        const fill = new Fill();

        if (state === 422) {
            fill.setColor("orange")
        }

        if (state === 409) {
            fill.setColor(darkGrey)
        }

        if (state === 500) {
            fill.setColor("red")
        }


        const errorStyle = new Style({
            geometry: new Point(centerPointError),
            image: new Circle({
                fill: fill,
                radius: 24,
                stroke: new Stroke({
                    color: black,
                    width: 2,
                })
                // offsetX: 24,
                // offsetY: 24,
            }),
            text: new Text({
                text: state,
                font: 'bold 20px sans-serif',
                textAlign: 'center',
                textBaseline: 'middle',
                fill: new Fill({ color: "white" }),
                stroke: new Stroke({
                    color: black + "aa",
                    width: 1,
                })

                // offsetX: 24,
                // offsetY: 24,

            })
        })
        new_styles.push(errorStyle)


    }








    new_styles.forEach((s) => s.setZIndex(zIndex.value))


    return new_styles

};




</script>
